// Modal names
export const MODAL_NAME = {
  CHANGE_PASSWORD: `ChangePassword`,
  CHANGE_USERNAME: `ChangeUsername`,
  ENABLE_MFA: `EnableMfa`,
  DISABLE_MFA: `DisableMfa`,
  ADD_NEW_MFA_METHOD: `AddNewMfaMethod`
};

// Post message types. Used when posting messages between iframes.
export const POST_MESSAGE = {
  SHOW_MODAL: 'ShowModal',
  UPDATE_MFA_STATUS: 'UpdateMfaStatus',
  RELOAD_PAGE: 'ReloadPage',
  SWITCH_ACCOUNT: 'SwitchAccount',
  PARENT_WINDOW_REDIRECT: 'ParentWindowRedirect'
};
